
import { useEffect, useState, useMemo } from "react";
import { useNavigate } from "react-router-dom";
import axios from "axios";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { getColumns } from "./columns";
import { DataTable } from "./data-table";
import { AddUserModal } from "./add-user-modal";

export default function UserManagement() {
  const navigate = useNavigate();
  const [users, setUsers] = useState([]);
  const [isAddUserModalOpen, setIsAddUserModalOpen] = useState(false);
  const [searchTerm, setSearchTerm] = useState("");

  const fetchUsers = async () => {
    try {
      const accessToken = localStorage.getItem("accessToken");
      const response = await axios.get(
        `${import.meta.env.VITE_API_URL}/users?limit=1000`,
        {
          headers: {
            Authorization: `Bearer ${accessToken}`,
          },
        }
      );
      setUsers(response.data.data || response.data || []);
    } catch (error) {
      console.error("Failed to fetch users:", error);
      setUsers([]); // Ensure users is an empty array on error
    }
  };

  useEffect(() => {
    const userRoles = JSON.parse(localStorage.getItem("user_data") || "{}").roles;
    if (!userRoles?.includes("admin")) {
      navigate("/dashboard");
    }
    fetchUsers();
  }, [navigate]);

  const handleAddUser = async (userData) => {
    try {
      const accessToken = localStorage.getItem("accessToken");
      await axios.post(`${import.meta.env.VITE_API_URL}/user`, userData, {
        headers: {
          Authorization: `Bearer ${accessToken}`,
        },
      });
      setIsAddUserModalOpen(false);
      fetchUsers(); // Refetch users after adding a new one
    } catch (error) {
      console.error("Failed to add user:", error);
    }
  };

  const filteredUsers = useMemo(() => {
    if (!searchTerm) {
      return users;
    }
    return users.filter(
      (user) =>
        user.name.toLowerCase().includes(searchTerm.toLowerCase()) ||
        user.email.toLowerCase().includes(searchTerm.toLowerCase())
    );
  }, [users, searchTerm]);

  const columns = getColumns(fetchUsers);

  return (
    <div className="container mx-auto py-10">
      <div className="flex justify-between items-center mb-6">
        <h1 className="text-2xl font-bold">User Management</h1>
        <div className="flex items-center gap-4">
          <Input
            placeholder="Search by name or email..."
            value={searchTerm}
            onChange={(e) => setSearchTerm(e.target.value)}
            className="max-w-sm"
          />
          <Button onClick={() => setIsAddUserModalOpen(true)}>Add User</Button>
        </div>
      </div>
      <DataTable columns={columns} data={filteredUsers} fetchUsers={fetchUsers} />
      <AddUserModal
        open={isAddUserModalOpen}
        onClose={() => setIsAddUserModalOpen(false)}
        onAddUser={handleAddUser}
      />
    </div>
  );
}
